class BESSAppProjectProfilerItem extends BESSAppBase {
    constructor(profiler, root, item, fields) {
        super();
        this.profiler = profiler;
        this.item = item;
        this.fields = fields;
        this.views = {
            root: root,
            editButton: root.find('.app-action-edit'),
            removeButton: root.find('.app-action-remove'),
        }
        this.views.editButton.bindClickEvent(this, this.#onEditItem);
        this.views.removeButton.bindClickEvent(this, this.#onRemoveItem);
        if (item === undefined) {
            console.log("here");
        }
        new BESSAppDependentView(this.views.root, this.item.dependencies);

        this.forEach(this.fields, this.#setupField);
    }

    start() {
        this.forEach(this.fields, this.#startField);
    }

    getField(fieldName) {
        return this.views.root.find('.app-editor-field[data-variable="' + fieldName + '"]');
    }


    #onEditItem() {
        new BESSAppProjectEditorModal(this.profiler).openAndEditItem(this.item);
    }

    #onRemoveItem() {
        let removeWhat = this.views.removeButton.attr('title') + "? <strong>This operation cannot be undone</strong>";
        let itemNo = this.item.itemNo;
        let editorId = this.profiler.data.editorId;

        this.askUserToConfirmSeriousOperation("Remove " + this.profiler.data.what , removeWhat, function(){
            this.showDoingWork('Remove', 'Removing ' + this.profiler.data.what);
            BESSAppProjectEditorAPIService.instance().apiRemove(editorId, itemNo, function(result) {
                let event = new BESSAppProjectEditorSavedEvent(result);
                this.fireEvent(event);
                this.hideDoingWork();
            }.bind(this));
        }.bind(this));
    }

    #setupField(field) {

        if (field.dependencies.length > 0) {
            new BESSAppDependentView(
                this.fieldViewForAttribute(field.variable),
                field.dependencies,
                {
                    item: this.item
                });
        }
    }

    #startField(field) {
        let fieldNo = this.fields.indexOf(field);
        let value = this.item.values[fieldNo];
        this.views.root.hideIf(!value.isApplicable);
        this.fireEvent(new BESSAppQuestionAnswerDependencyEvent(this.item, field, value), true);
        this.fireEvent(new BESSAppItemQuestionAnswerDependencyEvent(this.item, field, value), true);

        let view = this.fieldViewForAttribute(field.variable);
        if (!view.hasClass('dependency-hidden')) {
            view.hideIf(!value.isApplicable);
        }
    }

    fieldViewForAttribute(attribute) {
        return this.views.root.find(".app-editor-field-" + attribute);
    }

}